<article class="match-preview">
  <button
    type="button"
    class="match-preview__info"
    (click)="openDetail.emit(match().id)"
  >
    <span class="sr-only">{{ 'matchDetail.openDetails' | translate }}</span>
    @if (match().isOutright) {
      <div class="match-preview__outright">
        <span class="match-preview__outright-name">{{ match().outrightLabel }}</span>
        @if (match().metaLines[0]; as outrightTime) {
          <span class="match-preview__outright-time">{{ outrightTime }}</span>
        }
      </div>
    } @else {
      <div class="match-preview__meta" [class.match-preview__meta--live]="match().isLive">
        @if (match().statusTag) {
          <span class="match-preview__status">{{ match().statusTag }}</span>
        }

        @for (line of match().metaLines; track $index) {
          <span class="match-preview__meta-line">{{ line }}</span>
        }
      </div>

      <div class="match-preview__teams">
        <span class="match-preview__team">{{ match().homeTeam }}</span>
        <span class="match-preview__team">{{ match().awayTeam }}</span>
      </div>

      <div class="match-preview__scores">
        @for (line of match().scoreLines; track $index) {
          <span class="match-preview__score">{{ line }}</span>
        }
      </div>
    }
  </button>

  @for (selection of visibleQuickSelections(); track selection.key) {
    <button
      type="button"
      class="match-preview__selection sb-odds-button"
      [class.match-preview__selection--outright]="match().isOutright"
      [class.sb-odds-button--selected]="selection.selected"
      [disabled]="!selection.available"
      [appOddsValueFlash]="selection.available ? selection.value : null"
      [attr.aria-pressed]="selection.selected"
      [attr.aria-label]="'accessibility.oddsSelection' | translate: {
        match: match().isOutright ? match().outrightLabel : match().homeTeam + ' – ' + match().awayTeam,
        selection: selection.selectionLabel || selection.headerLabel,
        odds: selection.available && selection.value !== null
          ? (selection.value | number: '1.1-2')
          : ('betslip.unavailable' | translate)
      }"
      [attr.title]="match().isOutright ? selection.selectionLabel : null"
      (click)="onSelectionClick(selection)"
    >
      @if (match().isOutright) {
        <span class="match-preview__selection-content">
          <span class="match-preview__selection-label">{{ selection.selectionLabel }}</span>
          <span class="match-preview__selection-value">
            @if (selection.available && selection.value !== null) {
              {{ selection.value | number: '1.1-2' }}
            } @else {
              -
            }
          </span>
        </span>
      } @else {
        @if (selection.available && selection.value !== null) {
          {{ selection.value | number: '1.1-2' }}
        } @else {
          -
        }
      }
    </button>
  }

  <button
    type="button"
    class="match-preview__more sb-odds-button sb-odds-button--ghost"
    [attr.aria-label]="'accessibility.moreMarkets' | translate: {
      count: match().moreMarketsCount,
      match: match().isOutright ? match().outrightLabel : match().homeTeam + ' – ' + match().awayTeam
    }"
    (click)="openDetail.emit(match().id)"
  >
    <span>+{{ match().moreMarketsCount }}</span>
  </button>
</article>
